// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"7bad9c96","254":"12070984","256":"8adf275a","498":"ad09e19a","616":"81a82b99","617":"02813519","657":"3797104f"}[chunkId] + ".chunk.js";
};